import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { useGetTranslations } from '@/composables/useGetTranslations';
import { useLocalization } from '~/composables/_next/useLocalization';
export default /*#__PURE__*/_defineComponent({
  __name: 'AzSeoBlock',
  props: {
    title: null,
    description: null,
    links: null
  },
  setup: function setup(__props) {
    var props = __props;
    var AzExpandableText = function AzExpandableText() {
      return import('~/components/_next/molecules/AzExpandableText.vue');
    };
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var _useLocalization = useLocalization(),
      locale = _useLocalization.locale;
    var _useParseDocumentToHt = useParseDocumentToHtml(props.description, [], {}, props.links, locale),
      parsedText = _useParseDocumentToHt.html;
    return {
      __sfc: true,
      AzExpandableText: AzExpandableText,
      translate: translate,
      props: props,
      locale: locale,
      parsedText: parsedText
    };
  }
});